import React from 'react';

export const name = 'flag-IS';

export const FlagIS = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_251)">
      <mask
        id="mask0_2_251"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_251)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#EEEEEE"
        />
        <path
          d="M0.412476 15.1312C1.10236 17.6714 2.60767 19.9145 4.69686 21.5156V15.1312H0.412476ZM10.9594 23.9531C11.3054 23.9836 11.6526 23.9992 12 24C14.6376 24.0007 17.202 23.1323 19.2966 21.5292C21.3912 19.9261 22.8992 17.6775 23.5875 15.1312H10.9547V23.9531H10.9594ZM23.5875 8.86875C22.8522 6.14934 21.1836 3.77532 18.874 2.16244C16.5643 0.549558 13.7609 -0.199356 10.9547 0.0468543V8.86875H23.5875ZM4.69686 2.48436C2.60767 4.08546 1.10236 6.32859 0.412476 8.86875H4.69686V2.48436Z"
          fill="#0052B4"
        />
        <path
          d="M23.8969 10.4344H9.38906V0.285919C8.29706 0.527925 7.24452 0.92242 6.26249 1.45779V10.4344H0.103124C-0.0324622 11.4737 -0.0324622 12.5263 0.103124 13.5656H6.26249V22.5422C7.24452 23.0775 8.29706 23.472 9.38906 23.7141V13.5656H23.8969C24.0322 12.5263 24.0322 11.4737 23.8969 10.4344Z"
          fill="#D80027"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_251">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
